import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroModule } from './ng-zorro.module';
import { NoRouteComponent } from './components/not-found-pages/no-route/no-route.component';
import { MaxTabsLimitExceededComponent } from './components/info-page/info-page.component';
import { HeaderComponent } from './components/header/header.component';
import { RouterModule } from '@angular/router';
import { NgApexchartsModule } from 'ng-apexcharts';
import { HezkyFormComponent } from './components/hezky-form/hezky-form.component';
import { GenericConfirmationDialogComponent } from './components/generic-confirmation-dialog/generic-confirmation-dialog.component';
import { IncidentCardComponent } from './components/incident-card/incident-card.component';
import { AssetCardsComponent } from './components/asset-cards/asset-cards.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SelectAllDirective } from './directives/select-all.directive';
import { NotificationComponent } from './components/notification/notification.component';
import { AllowOnlyNumberDirective } from './directives/number-only.directive';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { DeepLinkPageComponent } from './components/deep-link-page/deep-link-page.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { NzHighlightPipe } from 'ng-zorro-antd/core/highlight';
import { LocationTreeComponent } from '../modules/location-tree/location-tree.component';
import { SensorSortPipe } from './pipes/sensor-sort.pipe';
import { ReportNameModalComponent } from './components/modals/report-name-modal.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { TripCardComponent } from './components/trip-card/trip-card.component';
import { PhoneFormatPipe } from './pipes/phone-format.pipe';
import { TrIncidentCardComponent } from './components/tr-incident-card/tr-incident-card.component';
import { TrGraphComponent } from './components/tr-graph/tr-graph.component';
import { AddressInputGoogleComponent } from './components/address-input-google/address-input-google.component';
import { NoSpacesDirective } from './directives/no-space.directive';
import { GenericFilterDrawerComponent } from './components/generic-filter-drawer/generic-filter-drawer.component';
import { BatteryAndSignalComponent } from './components/battery-and-signal/battery-and-signal.component';
import { IncidentFormReportComponent } from './components/incident-form-report/incident-form-report.component';
import { RelativeTimePipe } from './pipes/relative-time.pipe';
import { IncidentModalComponent } from './components/modals/incident-modal/incident-modal.component';
import { AqiCardComponent } from './components/aqi/aqi-card/aqi-card.component';
import { AqiGraphComponent } from './components/aqi/aqi-graph/aqi-graph.component';
import { AqiHeatMapComponent } from './components/aqi/aqi-heat-map/aqi-heat-map.component';
import { AqiStatusBarComponent } from './components/aqi/aqi-status-bar/aqi-status-bar.component';
import { GlobalDatePipe } from './pipes/global-date.pipe';
import { ChecklistViewComponent } from './components/modals/checklist-view/checklist-view.component';
import { AccountDisableComponent } from './components/info-page/account-disable.component';
import { FormsComponent } from '../modules/incidents/components/forms/forms.component';
import { StorageGraphComponent } from './components/storage-graph/storage-graph.component';
import { SecondsToHumanPipe } from './pipes/seconds-to-human.pipe';
import { TripRouteComponent } from './components/trip-route/trip-route.component';
import { AllowedCharsDirective } from './directives/allowed-chars.directive';
import { TripMapComponent } from '../modules/trips/components/trip-map/trip-map.component';
import { TripTimelineComponent } from '../modules/trips/components/trip-timeline/trip-timeline.component';
import { SeverityChipComponent } from './components/severity-chip/severity-chip.component';

@NgModule({
  declarations:[
    NoRouteComponent,
    MaxTabsLimitExceededComponent,
    AccountDisableComponent,
    HeaderComponent,
    RelativeTimePipe,
    HezkyFormComponent,
    GenericConfirmationDialogComponent,
    IncidentCardComponent,
    AssetCardsComponent,
    SelectAllDirective,
    NotificationComponent,
    PrivacyPolicyComponent,
    AboutUsComponent,
    ContactUsComponent,
    AllowOnlyNumberDirective,
    DeepLinkPageComponent,
    TermsAndConditionsComponent,
    LocationTreeComponent,
    SensorSortPipe,
    ReportNameModalComponent,
    TripCardComponent,
    PhoneFormatPipe,
    TrIncidentCardComponent,
    TrGraphComponent,
    AddressInputGoogleComponent,
    NoSpacesDirective,
    GenericFilterDrawerComponent,
    BatteryAndSignalComponent,
    IncidentFormReportComponent,
    IncidentModalComponent,
    AqiCardComponent,
    AqiGraphComponent,
    AqiHeatMapComponent,
    AqiStatusBarComponent,
    GlobalDatePipe,
    ChecklistViewComponent,
    FormsComponent,
    StorageGraphComponent,
    SecondsToHumanPipe,
    TripRouteComponent,
    AllowedCharsDirective,
    TripMapComponent,
    TripTimelineComponent,
    SeverityChipComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroModule,
    NgApexchartsModule,
    ScrollingModule,
    NzHighlightPipe,
    GoogleMapsModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroModule,
    NgApexchartsModule,
    ScrollingModule,
    HeaderComponent,
    RelativeTimePipe,
    HezkyFormComponent,
    GenericConfirmationDialogComponent,
    IncidentCardComponent,
    AssetCardsComponent,
    SelectAllDirective,
    NotificationComponent,
    AllowOnlyNumberDirective,
    PrivacyPolicyComponent,
    AboutUsComponent,
    ContactUsComponent,
    TermsAndConditionsComponent,
    DeepLinkPageComponent,
    SensorSortPipe,
    ReportNameModalComponent,
    GoogleMapsModule,
    TripCardComponent,
    PhoneFormatPipe,
    TrIncidentCardComponent,
    TrGraphComponent,
    AddressInputGoogleComponent,
    NoSpacesDirective,
    GenericFilterDrawerComponent,
    BatteryAndSignalComponent,
    IncidentFormReportComponent,
    IncidentModalComponent,
    AqiCardComponent,
    AqiGraphComponent,
    AqiHeatMapComponent,
    AqiStatusBarComponent,
    GlobalDatePipe,
    ChecklistViewComponent,
    AccountDisableComponent,
    FormsComponent,
    StorageGraphComponent,
    SecondsToHumanPipe,
    TripRouteComponent,
    AllowedCharsDirective,
    TripMapComponent,
    TripTimelineComponent,
    SeverityChipComponent
  ],
  schemas : [NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA],
  providers: [DatePipe]
})
export class SharedModule { }
